<template>
  <v-layout data-qa="forgotpassword-layout-rzv0oi">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="forgotpassword-overlay-t2fcjgh">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="forgotpassword-progress-circular-6v8ltm"></v-progress-circular>
    </v-overlay>
    <v-flex v-if="showInputFields" xs12 sm12 md12 lg12 xl12 data-qa="forgotpassword-flex-8cj7f">
      <!-- <font class="subtitle-2 font-weight-medium">{{
        $t("forgotPassword.formHeadline")
      }}</font> -->
      <!--Form Tabs Control-->
      <v-tabs
        v-if ="showCustomerTypeTabs"
        v-model="customerTypeCurrentTab"
        @change="handleCustomerTypeTabChange"
        :color="primaryColor"
       data-qa="forgotpassword-tabs-eqrkz">
        <v-tab v-for="(item, i) of customerTypeTabLabels" :key="i" :data-qa="`forgotpassword-tab-1u624e-${i}`">
          <!-- <v-icon
            dark
            left
            :data-qa="`forgotpassword-icon-qz4df-${i}`">
            {{ item.icon }}
          </v-icon> -->
          <dob-icon :iconKey="item.icon" dark left/>
          <font class="subtitle-1 text-capitalize font-weight-bold">{{
            item.label
          }}</font>
        </v-tab>
      </v-tabs>
      <v-card-subtitle data-qa="forgotpassword-card-subtitle-z7g0zl">
        {{ currentSubTitle }}
      </v-card-subtitle>
      <v-tabs
        v-if="showParamTypeTabs"
        v-model="currentTab"
        @change="handleParamTypeTabChange"
        :color="primaryColor"
        dense
       data-qa="forgotpassword-tabs-prjkhk">
        <v-tab v-for="(item, i) of tabLabels" :key="i" :data-qa="`forgotpassword-tab-utd9rzu-${i}`">
          <font class="subtitle-1 text-capitalize font-weight-bold">{{
            item
          }}</font>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentTab" data-qa="forgotpassword-tabs-items-c25fjc">
        <v-tab-item data-qa="forgotpassword-tab-item-im4kko">
          <v-flex xs12 sm12 md10 lg10 xl10 data-qa="forgotpassword-flex-nlu1bn">
            <Form
              :config="{
                label: '',
                name: 'ForgotPassword',
                isEnabled: true,
                toolbar: false,
                form: schema.forgotPasswordDetails,
              }"
            ></Form>
          </v-flex>
        </v-tab-item>
        <v-tab-item data-qa="forgotpassword-tab-item-tafzdn">
          <v-flex xs12 sm12 md10 lg10 xl10 data-qa="forgotpassword-flex-y9yzga">
            <Form
              :config="{
                label: '',
                name: 'ForgotPassword',
                isEnabled: true,
                toolbar: false,
                form: schema.forgotPasswordDetails,
              }"
            ></Form>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    <v-flex class="d-flex justify-start" data-qa="forgotpassword-flex-e5fy0f">
      <v-card-actions data-qa="forgotpassword-card-actions-kbvoovk">
        <v-spacer data-qa="forgotpassword-spacer-j2ler6"  />
        <!-- partySearch onNext isPhoneNumberRegistered-->
        <v-btn
          @click="searchCustomer"
          :color="primaryColor"
          :disabled="
            enableNext || !dataModel.phoneNumber || !dataModel.userID.length
          "
          style="margin-left: 32px;"
          class="text-capitalize font-weight-bold white--text py-2 px-4"
           data-qa="forgotpassword-btn-7kid3z">{{ $t("forgotPassword.button.nextBtn") }}</v-btn
        >
      </v-card-actions>
    </v-flex>
    </v-flex>
    <!-- Reset Password -->
    <v-flex v-if="showNewPasswordSection" data-qa="forgotpassword-flex-r2lqg">
      <!-- Common Set Password Component -->
      <SetPassword
        :config="{
          enableUserId: true,
          enableLoginId: false,
          userID: schema.forgotPasswordDetails.model.userID,
          roundedPwdBtn: true,
          enableOtpModal: false,
          showSuccessModal: false,
          btnLabel: $t('forgotPassword.button.resetPassword'),
          fromScreen: 'forgotPassword'
        }"
      />
    </v-flex>

    <!-- Password set status -->
    <v-flex v-if="showPasswordResetSuccess" data-qa="forgotpassword-flex-k6dchl">
      <p data-qa="forgotpassword-p-hrtcgj">
        <inline-svg
          v-if="passwordChangeStatus"
          :src="getTickIcon()"
          width="90"
          height="90"
          aria-label="Tick Icon"
          data-qa="pwd-success"
        ></inline-svg>
        <v-icon
          v-else
          size="80"
          :color="errorColor"
          data-qa="pwd-failure"
          >{{ passwordChangeStatusIcon }}</v-icon
        >
      </p>
      <p class="subtitle-1 font-weight-medium" data-qa="forgotpassword-p-zchmt">
        {{ passwordChangeStatusMsg }}
      </p>
      <v-card-actions class="pa-0" data-qa="forgotpassword-card-actions-cu40ie">
        <v-btn
          @click="goBackToLoginScreen"
          :color="primaryColor"
          data-qa="savePassword"
          class="text-capitalize white--text py-2 px-4"
          >{{ $t("common.goToLoginLabel") }}</v-btn
        >
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import { required } from '@/core/_helpers/validationRules'
import SetPassword from '@/components/DOB-SetPassword/SetPassword.vue'
import CommonService from '@/service/commonService.js'
import getFormConfig from '@/util/formUtility.js'
import event from '@/util/event'
import moment from 'moment'
import preload from '@/util/preload'
import handleError from '../../core/_helpers/errorHandler'
import preLoginMixin from '@/core/mixins/preloginScreensMixin'

export default {
  name: 'ForgotPassword',
  components: {
    SetPassword,
    Form: () => import('@/components/DOB-Form/Form.vue')
  },
  mixins: [preLoginMixin],
  data () {
    return {
      enableNext: true,
      showInputFields: true,
      showOTPSection: false,
      showNewPasswordSection: false,
      showPasswordResetSuccess: false,
      isPhoneNumberRegistered: false,
      allFieldsAreValid: false,
      loaderEnabled: false,
      passwordChangeStatus: false,
      passwordChangeStatusMsg: '',
      passwordChangeStatusIcon: '',
      isSmeCustomerEnabled: false,
      newPassword: '',
      userID: '',
      currentTab: 0,
      tabLabels: [
        this.$t('forgotPassword.tabLabels.customerId'),
        this.$t('forgotPassword.tabLabels.accNumber')
      ],
      schema: {
        forgotPasswordDetails: { exists: true }
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        }
      },
      currentSubTitle: '',
      showCustomerTypeTabs: false,
      isCustomerParamEnabled: false,
      showParamTypeTabs: false,
      customerTypeTabLabels: [
        { icon: 'forgotpassword_personaltab', label: 'Personal' },
        { icon: 'forgotpassword_smetab', label: 'SME' }
      ],
      customerTypeCurrentTab: 0,
      enableOTP: this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.enableOTP,
      loginMode: this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.userModeTabs,
      defaultSelectedLoginMode: this.$appSettings.defaultConfigurations.loginPageScreens.defaultSelectedLoginMode,
      paramType: this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.customerIdOrAccountNumberTabs,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      dataModel: {},
      otpData: {},
      fromScreen: 'forgotPassword',
      partyID: '',
      IBANAccountFormatEnabled: this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.enableIBANAccountFormat,
      isdCodeSelectionDisabled: this.$appSettings.defaultConfigurations.loginPageScreens.forgotPasswordScreen.disableISDCodeSelection
    }
  },
  async created () {
    this.currentSubTitle = this.$t('login.actionScreen.subHeadings.forgotPasswordLabel')
    this.loaderEnabled = true
    this.setTabs()
    await this.getFormData(`ForgotPassword-${this.$i18n.locale}`)
    this.loaderEnabled = false
    event.$on('isValid', (arg) => {
      this.enableNext = !arg
    })
    event.$on('checkLoginScreenAction', (arg) => {
      arg && this.formMethods(arg)
    })
    event.$on('resetPwdSuccess', (args) => {
      if (args.status) {
        this.otpData = args.otpData
        this.newPassword = args.password
        this.userID = this.schema.forgotPasswordDetails.model.userID
        this.setPassword()
      }
    })
  },
  updated () {
    this.setParamTabs()
  },
  methods: {
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    async getFormData () {
      try {
        this.loaderEnabled = true
        const componentSchema = await CommonService.getFormData(
          `ForgotPassword-${this.$i18n.locale}`
        )
        const data = getFormConfig(componentSchema)
        this.schema.forgotPasswordDetails = data
        this.dataModel = data.model
        const countryCodes = JSON.parse(localStorage.getItem('countryCode')) || []
        this.schema.forgotPasswordDetails.schema.countryCode.items = countryCodes
        // Show SME field
        this.setSMERelatedData(true)
        // set national id types
        if (
          this.schema.forgotPasswordDetails.schema &&
          this.schema.forgotPasswordDetails.schema.idTypes
        ) {
          const nationalIDType = JSON.parse(
            sessionStorage.getItem('PARTYIDTYPE')
          )
          if (nationalIDType) {
            const nationalIdTypesArr = []
            nationalIDType.forEach((code) => {
              nationalIdTypesArr.push({
                text: code.codeDescription,
                value: code.codeReference
              })
            })
            this.schema.forgotPasswordDetails.schema.idTypes.items = nationalIdTypesArr
          }
        }
        event.$emit('resetFormValidation', true)
        if (this.$appSettings.defaultConfigurations.countryISDCode && this.$appSettings.defaultConfigurations.defaultCountryCode && countryCodes) {
          this.schema.forgotPasswordDetails.schema.countryCode['item-value'] = (item) => `${item.dial_code}_${item.code}`
          const { countryISDCode, defaultCountryCode } = this.$appSettings.defaultConfigurations
          this.schema.forgotPasswordDetails.model.countryCode = `${countryISDCode}_${defaultCountryCode}`
        }
        if (this.isdCodeSelectionDisabled) this.schema.forgotPasswordDetails.schema.countryCode.disabled = true
        this.loaderEnabled = false
      } catch (e) {
        console.log(e)
      }
    },
    /** Set Tabs to display - 'Profile' / 'SME'
     * Display tabs only if default login form selection is 'Both'
    */
    setTabs () {
      const loginMode = this.loginMode.toLowerCase()
      const defaultSelectedLoginMode = this.defaultSelectedLoginMode.toLowerCase()
      switch (loginMode) {
        case 'sme':
          this.showCustomerTypeTabs = false
          this.isSmeCustomerEnabled = true
          this.customerTypeCurrentTab = 1
          break
        case 'personal':
          this.showCustomerTypeTabs = false
          this.isSmeCustomerEnabled = false
          this.customerTypeCurrentTab = 0
          break
        case 'both':
          this.showCustomerTypeTabs = true
          this.customerTypeCurrentTab = defaultSelectedLoginMode === 'personal' ? 0 : 1
          this.isSmeCustomerEnabled = this.customerTypeCurrentTab === 1
          break
      }
      this.setConfigTabs()
    },
    setConfigTabs () {
      // Parameter types tab - customerId / accountNumber / Both
      let paramType = ''
      paramType = this.customerTypeCurrentTab === 0
        ? this.paramType.forPersonal.toLowerCase()
        : this.paramType.forSme.toLowerCase()
      switch (paramType) {
        case 'customerid':
          this.currentTab = 0
          this.showParamTypeTabs = false
          this.isCustomerParamEnabled = true
          break
        case 'accountnumber':
          this.currentTab = 1
          this.showParamTypeTabs = false
          this.isCustomerParamEnabled = false
          break
        case 'both':
          this.showParamTypeTabs = true
          this.currentTab = 0
          this.isCustomerParamEnabled = true
          break
      }
    },
    setParamTabs () {
      if (this.currentTab === 0 && this.schema.forgotPasswordDetails.schema) {
        this.schema.forgotPasswordDetails.schema.customerID.hidden = false
        this.schema.forgotPasswordDetails.schema.customerID.rules.push(required('Required'))
        this.schema.forgotPasswordDetails.schema.accountNumber.hidden = true
        this.schema.forgotPasswordDetails.schema.accountNumber.rules = []
        this.schema.forgotPasswordDetails.schema.lastName.hidden = true
        this.schema.forgotPasswordDetails.schema.lastName.rules = []
        this.schema.forgotPasswordDetails.schema.countryCode['menu-props'].contentClass = 'custom-dropdown-forgotPassword-custId'
      }
      if (this.currentTab === 1 && this.schema.forgotPasswordDetails.schema) {
        this.schema.forgotPasswordDetails.schema.lastName.hidden = false
        this.schema.forgotPasswordDetails.schema.lastName.rules.push(required('Required'))
        this.schema.forgotPasswordDetails.schema.accountNumber.hidden = false
        this.schema.forgotPasswordDetails.schema.accountNumber.rules.push(required('Required'))
        this.schema.forgotPasswordDetails.schema.customerID.hidden = true
        this.schema.forgotPasswordDetails.schema.customerID.rules = []
        this.schema.forgotPasswordDetails.schema.countryCode['menu-props'].contentClass = 'custom-dropdown-forgotPassword-accNo'
        if (this.accountType === 'IB') this.schema.forgotPasswordDetails.schema.accountNumber.label = this.$t('internationalPayments.payeeAccNoLabel')
      }
    },
    handleCustomerTypeTabChange () {
      if (this.customerTypeCurrentTab === 0) {
        this.isSmeCustomerEnabled = false
      } else this.isSmeCustomerEnabled = true
      // Set SME field
      // this.setSMERelatedData()
      this.setParamTabs()
      this.setConfigTabs()
      this.getFormData()
    },
    handleParamTypeTabChange () {
      this.getFormData(`ForgotPassword-${this.$i18n.locale}`)
      if (this.currentTab === 0) {
        this.isCustomerParamEnabled = true
      } else this.isCustomerParamEnabled = false
    },
    setSMERelatedData (isPristine) {
      // Show SME field
      if (this.schema.forgotPasswordDetails.schema && this.schema.forgotPasswordDetails.schema.smeID) {
        this.schema.forgotPasswordDetails.schema.smeID.hidden = !this.isSmeCustomerEnabled
        this.isSmeCustomerEnabled ? this.schema.forgotPasswordDetails.schema.smeID.rules.push(required('Required')) : this.schema.forgotPasswordDetails.schema.smeID.rules = []
      }
    },
    async onNext (customerIdFromPartySearch) {
      if (this.customerTypeCurrentTab === 1 && this.dataModel.smeID) {
        const customerID = this.currentTab === 1 ? customerIdFromPartySearch : this.dataModel.customerID
        if (await this.validateCustomerRelationDetails(customerID, this.dataModel.smeID)) {
          this.proceed(customerIdFromPartySearch)
        } else {
          this.partyNotFound('invalidDetails')
        }
      } else {
        this.proceed(customerIdFromPartySearch)
      }
    },
    proceed (customerIdFromPartySearch) {
      this.storeData(customerIdFromPartySearch)
      this.onPartyVerification()
    },
    storeData (customerIdFromPartySearch) {
      this.$store.dispatch('profileStore/setProfileData', {
        partyDetails: {
          customerID: this.dataModel?.customerID || customerIdFromPartySearch,
          dateOfBirth: this.dataModel?.dateOfBirth,
          emailAddress: this.dataModel?.emailAddress,
          firstName: this.dataModel?.firstName,
          lastName: this.dataModel?.lastName,
          idNumber: this.dataModel?.idNumber,
          idTypes: this.dataModel?.idTypes,
          phoneNumber: this.dataModel?.phoneNumber,
          countryCode: this.dataModel?.countryCode?.split('_')[0]
        }
      })
    },
    async onPartyVerification () {
      // event.$emit('SEND_OTP', true)
      this.showOTPSection = false
      this.showInputFields = false
      await preload.getPasswordComplexity()
      this.showNewPasswordSection = true
    },
    onResetPassword () {
      this.showOTPSection = false
      this.showNewPasswordSection = false
      this.showPasswordResetSuccess = true
    },
    goBackToLoginScreen () {
      event.$emit('goBackToLoginScreen', true)
    },
    formMethods ({ e, action }) {
      if (action === 'blur') {
        switch (e.key) {
          case 'phoneNumber':
            this.checkPhoneValidation()
            break
          default:
        }
      } else if (action === 'input') {
        if (e.key === 'countryCode' && this.dataModel.countryCode && this.dataModel.phoneNumber) this.checkPhoneValidation()
        if (this.dataModel.accountNumber && this.dataModel.accountNumber.length) {
          if (this.accountType === 'IB') {
            this.dataModel.accountNumber = this.dataModel.accountNumber.toUpperCase()
          }
        }
        if (e.key === 'idTypes') {
          if (this.dataModel.idTypes && this.dataModel.idTypes.length) {
            this.schema.forgotPasswordDetails.schema.idNumber.rules.push(required('Required'))
            // this.schema.forgotLoginIdDetails.schema.idNumber.id.rules.push(required('Required'))
            // this.schema.forgotLoginIdDetails.model.idNumber = undefined
          } else {
            this.schema.forgotPasswordDetails.schema.idNumber.rules = []
            // this.schema.forgotPasswordDetails.model.idNumber = undefined
          }
          event.$emit('resetFormValidation', true)
        }

        if (e.key === 'idNumber') {
          if (this.dataModel.idNumber && this.dataModel.idNumber.length) {
            this.schema.forgotPasswordDetails.schema.idTypes.rules.push(required('Required'))
          } else {
            this.schema.forgotPasswordDetails.schema.idTypes.rules = []
            // this.schema.forgotPasswordDetails.model.idTypes = undefined
          }
          event.$emit('resetFormValidation', true)
        }

        switch (e.key) {
          case 'idTypes':
            this.changeIDtype()
            break
          default:
        }
      }
    },
    async searchCustomer () {
      await this.getUserData()
    },
    async checkPhoneValidation () {
      let resp = false
      let isRespAvailable = false
      const cc = this.dataModel?.countryCode?.split('_')[0] || ''
      const body = {
        mobileNumber: cc && this.dataModel.phoneNumber ? `${cc}${this.dataModel.phoneNumber}` : ''
      }
      this.loaderEnabled = true
      if (this.dataModel.phoneNumber && this.dataModel.phoneNumber.length > 4) {
        resp = await CommonService.validatePhoneNumber(body)
        isRespAvailable = true
      } else {
        isRespAvailable = false
      }
      // For Personal -> If response is 'true', phoneNo is registered
      this.isPhoneNumberRegistered = resp === true
      if (isRespAvailable) {
        if (this.isPhoneNumberRegistered) {
          this.schema.forgotPasswordDetails.schema.phoneNumber.hidden = true
          this.schema.forgotPasswordDetails.schema.phoneNumber.hidden = false
          this.schema.forgotPasswordDetails.schema.phoneNumber.error = false
          this.schema.forgotPasswordDetails.schema.phoneNumber['error-messages'] = ''
        } else {
          this.schema.forgotPasswordDetails.schema.phoneNumber.hidden = true
          this.schema.forgotPasswordDetails.schema.phoneNumber.appendIcon = ''
          this.schema.forgotPasswordDetails.schema.phoneNumber.hidden = false
          this.schema.forgotPasswordDetails.schema.phoneNumber.error = true
          this.schema.forgotPasswordDetails.schema.phoneNumber['error-messages'] = this.$t('forgotPassword.validationStatus.mobileNumberExistence')
        }
      } else this.isPhoneNumberRegistered = false
      this.loaderEnabled = false
    },
    proceedOnNext (existingPartyId) {
      if (this.currentTab === 1) {
        this.getAccountDetails(existingPartyId)
      } else this.partySearch()
    },
    async getAccountDetails (existingPartyId) {
      if (this.currentTab === 1 && this.dataModel.accountNumber) {
        const accDetails = await CommonService.checkAccountStatusFromBff(this.dataModel.accountNumber, this.accountType)
        if (accDetails && accDetails.accountStatus && (['activated', 'normal'].includes(accDetails.accountStatus.toLowerCase()) || (this.allowInactiveAccountPreLoginOperations && accDetails.accountStatus.toLowerCase() === 'inactive'))) {
          await this.partySearch(existingPartyId)
        } else if ((accDetails && accDetails.causes && accDetails.causes[0]?.code === '40280164') || (accDetails.error && accDetails?.error?.causes && accDetails?.error?.causes[0].code === '40280164')) {
          await this.partySearch(existingPartyId)
        } else if ((accDetails && accDetails.causes && accDetails.causes[0]?.code === '20600027') || (accDetails.error && accDetails?.error?.causes && accDetails?.error?.causes[0].code === '20600027')) {
          // Prelogin screen - customer is on the blacklist or invalid status
          // this.partyNotFound('pendingVerification')
          this.partySearch()
        } else {
          this.partyNotFound('invalidDetails')
        }
      }
    },
    async partySearch (existingPartyId) {
      // Validate user against entered info
      // Party search API call payload
      this.loaderEnabled = true
      let partySearchData = {}
      if (this.currentTab === 0) {
        if (this.dataModel.idNumber && this.dataModel.idTypes) {
          partySearchData = {
            // extra info
            customerId: this.dataModel.customerID,
            schema: this.schema.forgotPasswordDetails.schema,
            // actual payload
            identifier: this.dataModel.idNumber,
            idType: this.dataModel.idTypes,
            partyType: '1062',
            partyName: this.dataModel.firstName
              ? `${this.dataModel.firstName}%`
              : null,
            dateOfBirthOrFormation: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: !!this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null
          }
        } else {
          partySearchData = {
            // extra info
            customerId: this.dataModel.customerID,
            schema: this.schema.forgotPasswordDetails.schema,
            // actual payload
            partyName: this.dataModel.firstName
              ? `${this.dataModel.firstName}%`
              : null,
            dateOfBirthOrFormation: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null
          }
        }
      } else {
        if (this.dataModel.idNumber && this.dataModel.idTypes) {
          partySearchData = {
            customerId: this.dataModel.customerID,
            idNumber: this.dataModel.idNumber,
            idType: this.dataModel.idTypes,
            firstName: this.dataModel.firstName,
            lastName: this.dataModel.lastName,
            dateOfBirth: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null,
            accountNumber: this.dataModel.accountNumber,
            accountType: this.accountType
          }
        } else {
          partySearchData = {
            customerId: this.dataModel.customerID,
            firstName: this.dataModel.firstName,
            lastName: this.dataModel.lastName,
            dateOfBirth: this.dataModel.dateOfBirth ? moment(this.dataModel.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.dataModel.phoneNumber.length > 0 ? this.dataModel.phoneNumber : '',
            email: this.dataModel?.emailAddress?.length > 0 ? this.dataModel.emailAddress : null,
            accountNumber: this.dataModel.accountNumber,
            accountType: this.accountType
          }
        }
      }

      const partyDataValidation = this.currentTab === 1 ? await CommonService.partySearchByAccount(partySearchData) : await CommonService.partyUserSearch(partySearchData)

      if (partyDataValidation && partyDataValidation?.validationResponse && existingPartyId === partyDataValidation?.customerId) {
        this.partyID = partyDataValidation?.customerId
        this.onNext(partyDataValidation?.customerId)
      } else {
        partyDataValidation?.cause ? this.partyNotFound(partyDataValidation.cause) : this.partyNotFound('invalidDetails')
      }
      this.loaderEnabled = false
    },
    async validateCustomerRelationDetails (customerID, smeID) {
      const checkResp = await CommonService.validateCustomerRelationDetails(customerID, smeID)
      return typeof checkResp === 'boolean' && checkResp === true
    },
    async getUserData () {
      let partyData = {}
      try {
        this.loaderEnabled = true
        partyData = await CommonService.getUserDataFromBff(
          this.dataModel.userID
        )
      } catch (e) {
        console.log(e)
        this.loaderEnabled = false
      }

      // Empty object or null indicates potential connection drop / backend unreachable
      if (!partyData || (typeof partyData === 'object' && Object.keys(partyData).length === 0)) {
        this.loaderEnabled = false
        return
      }

      if (
        partyData &&
        (partyData.userLoginId
          ? partyData.userLoginId?.toLowerCase() === this.dataModel.userID?.toLowerCase()
          : false)
      ) {
        if (this.currentTab === 1) {
          this.proceedOnNext(partyData.customerId)
        } else this.partySearch(partyData.customerId)
      } else {
        this.partyNotFound('userId')
      }
      this.loaderEnabled = false
    },
    partyNotFound (data) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          saveCallback: this.resetScreen,
          content: this.$t(`forgotPassword.validationStatus.${data}`),
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    changeIDtype () {
      this.schema.forgotPasswordDetails.schema.idNumber.hidden =
        this.dataModel.idTypes === undefined
    },
    async setPassword () {
      try {
        this.loaderEnabled = true
        const passwordPayload = {
          ...this.otpData,
          userLoginId: this.userID,
          newPassword: this.newPassword,
          authenticationMethod: 'LOGINID_PASSWORD',
          channelMode: 'WEB',
          partyId: this.partyID
        }
        const status = await CommonService.setforgotPassword(passwordPayload)
        if (status.data && !status.error) {
          this.passwordChangeStatus = true
          this.passwordChangeStatusIcon = 'mdi-checkbox-marked-circle-outline'
          this.passwordChangeStatusMsg = this.$t(
            'forgotPassword.resetPasswordSuccess'
          )
        } else {
          if (['11400361', '11400360'].includes(status.error.response.data.causes[0].code)) {
            event.$emit('prelogin_invalid_otp')
            this.loaderEnabled = false
            return
          } else if (status.error.response.data.causes[0].code === 'FEUS-000040') {
            handleError(status.error)
            event.$emit('reset_OTPField', true)
            this.loaderEnabled = false
            return
          } else if (['FEUS-000068', 'FEUS-000071'].includes(status.error.response.data.causes[0].code)) {
            // New password cannot be identical to the last 5 passwords/ most recent password - We need to retrigger the otp in this case
            event.$emit('prelogin_resend_otp', true)
            handleError(status.error)
            this.loaderEnabled = false
          } else {
            handleError(status.error)
            event.$emit('reset_OTPField', true)
            this.passwordChangeStatus = false
            this.passwordChangeStatusIcon = 'mdi-close-circle-outline'
            this.passwordChangeStatusMsg = this.$t(
              'forgotPassword.resetPasswordFailure'
            )
          }
        }
        this.passwordChangeStatus ? this.onResetPassword() : this.onResetFailed()
        this.loaderEnabled = false
      } catch (e) {
        console.log(e)
      }
    },
    onResetFailed () {
      event.$emit('resetPasswordFailed')
    }
  },
  watch: {
    currentTab () {
      this.setParamTabs()
    }
  },
  beforeDestroy () {
    event.$off('resetPwdSuccess')
    event.$off('checkLoginScreenAction')
  }
}
</script>
